import { ZonedDateTime, Maybe } from '@csp/csp-common-model';
import { ScheduleDateService } from '@csp/csp-common-scheduling';
import { QuestionnaireSchedule } from '../model/QuestionnaireSchedule';
import { QuestionnaireType } from '../type/QuestionnaireType';

export const filterSchedule = (
  schedule: QuestionnaireSchedule,
  excludeType?: Maybe<QuestionnaireType>,
): QuestionnaireSchedule => {
  if (!excludeType) {
    return schedule;
  }
  return {
    ...schedule,
    activeVersionWindows: schedule.activeVersionWindows.map(versionWindow => ({
      ...versionWindow,
      requests: versionWindow.requests.filter(request => request.config.type !== excludeType),
    })),
  };
};

export const isWindowEnded = (now: ZonedDateTime, windowEnd?: ZonedDateTime): boolean => {
  if (!windowEnd) {
    return false;
  } else if (now.unixTimeMillis === windowEnd.unixTimeMillis) {
    return true;
  } else {
    return ScheduleDateService.isBeforeDateTime(windowEnd, now);
  }
};
